// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analytics-container {
  padding: 0;
  background: transparent;
  border-radius: 16px;
  transition: all 0.3s ease;
}

.analytics-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  flex-wrap: wrap;
  gap: 16px;
}

.analytics-header h2 {
  font-size: 1.8rem;
  color: #2c3e50;
  margin: 0;
  transition: color 0.3s ease;
  font-weight: 600;
}

.dark-mode .analytics-header h2 {
  color: #f5f5f5;
}

.time-range-selector {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.time-range-selector button {
  padding: 8px 16px;
  border: 2px solid #3498db;
  border-radius: 10px;
  background: transparent;
  color: #3498db;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.time-range-selector button:hover {
  background: rgba(52, 152, 219, 0.1);
}

.dark-mode .time-range-selector button {
  border-color: #4CA1D8;
  color: #4CA1D8;
}

.dark-mode .time-range-selector button:hover {
  background: rgba(76, 161, 216, 0.1);
}

.time-range-selector button.active {
  background: #3498db;
  color: white;
  box-shadow: 0 4px 6px rgba(52, 152, 219, 0.2);
}

.dark-mode .time-range-selector button.active {
  background: #4CA1D8;
  box-shadow: 0 4px 6px rgba(76, 161, 216, 0.3);
}

.analytics-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 24px;
  margin-bottom: 32px;
}

.summary-card {
  background: white;
  padding: 24px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.dark-mode .summary-card {
  background: #2d2d2d;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-color: rgba(255, 255, 255, 0.05);
}

.summary-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
}

.dark-mode .summary-card:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.summary-icon {
  font-size: 2.2rem;
  color: #3498db;
  margin-right: 20px;
  background: rgba(52, 152, 219, 0.1);
  padding: 16px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dark-mode .summary-icon {
  color: #4CA1D8;
  background: rgba(76, 161, 216, 0.15);
}

.summary-info {
  flex: 1 1;
}

.summary-info h3 {
  font-size: 1rem;
  color: #7f8c8d;
  margin: 0 0 8px 0;
  font-weight: 500;
}

.dark-mode .summary-info h3 {
  color: #aaa;
}

.summary-value {
  font-size: 1.8rem;
  font-weight: 700;
  color: #2c3e50;
  line-height: 1.2;
}

.dark-mode .summary-value {
  color: #f5f5f5;
}

.charts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
  gap: 24px;
  margin-bottom: 32px;
}

.chart-container {
  background: white;
  padding: 24px;
  border-radius: 16px;
  margin-bottom: 24px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.05);
  height: 350px;
}

.dark-mode .chart-container {
  background: #2d2d2d;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-color: rgba(255, 255, 255, 0.05);
}

.chart-header {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.chart-header h3 {
  color: #2c3e50;
  font-size: 1.2rem;
  transition: color 0.3s ease;
  margin: 0;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
}

.chart-header h3 svg {
  color: #3498db;
}

.dark-mode .chart-header h3 {
  color: #f5f5f5;
}

.dark-mode .chart-header h3 svg {
  color: #4CA1D8;
}

.analytics-insights {
  background: white;
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.dark-mode .analytics-insights {
  background: #2d2d2d;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-color: rgba(255, 255, 255, 0.05);
}

.analytics-insights h3 {
  color: #2c3e50;
  margin: 0 0 16px 0;
  font-size: 1.2rem;
  font-weight: 600;
}

.dark-mode .analytics-insights h3 {
  color: #f5f5f5;
}

.insights-list {
  display: grid;
  gap: 16px;
}

.insight-item {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 12px;
  color: #7f8c8d;
  line-height: 1.5;
  transition: all 0.3s ease;
}

.dark-mode .insight-item {
  background: #3d3d3d;
  color: #bbb;
}

.insight-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
}

.dark-mode .insight-item:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.insight-item strong {
  color: #2c3e50;
  margin-right: 8px;
  font-weight: 600;
}

.dark-mode .insight-item strong {
  color: #f5f5f5;
}

.analytics-filters {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.filter-select {
  padding: 10px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 10px;
  background: white;
  color: #2c3e50;
  transition: all 0.3s ease;
  font-size: 1rem;
  cursor: pointer;
  min-width: 150px;
}

.dark-mode .filter-select {
  background: #2d2d2d;
  border-color: #444;
  color: #f5f5f5;
}

.filter-select:focus {
  outline: none;
  border-color: #3498db;
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
}

.dark-mode .filter-select:focus {
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.2);
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 24px;
  margin-bottom: 32px;
}

.stat-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.dark-mode .stat-card {
  background: #2d2d2d;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-color: rgba(255, 255, 255, 0.05);
}

.stat-title {
  font-size: 1rem;
  color: #7f8c8d;
  margin: 0 0 16px 0;
  font-weight: 500;
}

.dark-mode .stat-title {
  color: #aaa;
}

.stat-value {
  font-size: 2rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 8px;
}

.dark-mode .stat-value {
  color: #f5f5f5;
}

.stat-change {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  font-weight: 500;
}

.change-positive {
  color: #2ecc71;
}

.change-negative {
  color: #e74c3c;
}

.dark-mode .change-positive {
  color: #2ecc71;
}

.dark-mode .change-negative {
  color: #e74c3c;
}

.table-container {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.05);
  overflow-x: auto;
  transition: all 0.3s ease;
}

.dark-mode .table-container {
  background: #2d2d2d;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-color: rgba(255, 255, 255, 0.05);
}

.analytics-table {
  width: 100%;
  border-collapse: collapse;
}

.analytics-table th,
.analytics-table td {
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.dark-mode .analytics-table th,
.dark-mode .analytics-table td {
  border-bottom-color: rgba(255, 255, 255, 0.05);
}

.analytics-table th {
  font-weight: 600;
  color: #7f8c8d;
}

.dark-mode .analytics-table th {
  color: #aaa;
}

/* Chart tooltips and legends */
.recharts-default-tooltip {
  background-color: white !important;
  border: none !important;
  border-radius: 10px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
  padding: 10px 14px !important;
}

.dark-mode .recharts-default-tooltip {
  background-color: #2d2d2d !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
}

.recharts-tooltip-label {
  color: #7f8c8d !important;
  font-size: 0.9rem !important;
  margin-bottom: 4px !important;
}

.dark-mode .recharts-tooltip-label {
  color: #aaa !important;
}

.recharts-tooltip-item {
  font-size: 0.9rem !important;
}

.recharts-legend-item {
  font-size: 0.9rem !important;
}

.dark-mode .recharts-legend-item-text {
  color: #f5f5f5 !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .analytics-container {
    padding: 0;
  }
  
  .analytics-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  
  .analytics-header h2 {
    font-size: 1.6rem;
  }
  
  .time-range-selector {
    width: 100%;
    overflow-x: auto;
    padding-bottom: 4px;
  }
  
  .charts-grid {
    grid-template-columns: 1fr;
  }
  
  .chart-container {
    padding: 16px;
    height: 300px;
  }
  
  .summary-card {
    padding: 16px;
  }
  
  .summary-icon {
    font-size: 1.8rem;
    padding: 12px;
  }
  
  .summary-value {
    font-size: 1.6rem;
  }
  
  .analytics-insights,
  .table-container,
  .stat-card {
    padding: 16px;
  }
}

@media (max-width: 480px) {
  .chart-container {
    height: 250px;
  }
  
  .summary-icon {
    margin-right: 12px;
    padding: 10px;
    font-size: 1.5rem;
  }
  
  .stat-value {
    font-size: 1.6rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/StudyTools/Analytics.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,2BAA2B;EAC3B,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,qCAAqC;EACrC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,+BAA+B;AAC/B;EACE,kCAAkC;EAClC,uBAAuB;EACvB,8BAA8B;EAC9B,oDAAoD;EACpD,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,oDAAoD;AACtD;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;IAGE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".analytics-container {\n  padding: 0;\n  background: transparent;\n  border-radius: 16px;\n  transition: all 0.3s ease;\n}\n\n.analytics-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.analytics-header h2 {\n  font-size: 1.8rem;\n  color: #2c3e50;\n  margin: 0;\n  transition: color 0.3s ease;\n  font-weight: 600;\n}\n\n.dark-mode .analytics-header h2 {\n  color: #f5f5f5;\n}\n\n.time-range-selector {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.time-range-selector button {\n  padding: 8px 16px;\n  border: 2px solid #3498db;\n  border-radius: 10px;\n  background: transparent;\n  color: #3498db;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.time-range-selector button:hover {\n  background: rgba(52, 152, 219, 0.1);\n}\n\n.dark-mode .time-range-selector button {\n  border-color: #4CA1D8;\n  color: #4CA1D8;\n}\n\n.dark-mode .time-range-selector button:hover {\n  background: rgba(76, 161, 216, 0.1);\n}\n\n.time-range-selector button.active {\n  background: #3498db;\n  color: white;\n  box-shadow: 0 4px 6px rgba(52, 152, 219, 0.2);\n}\n\n.dark-mode .time-range-selector button.active {\n  background: #4CA1D8;\n  box-shadow: 0 4px 6px rgba(76, 161, 216, 0.3);\n}\n\n.analytics-summary {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 24px;\n  margin-bottom: 32px;\n}\n\n.summary-card {\n  background: white;\n  padding: 24px;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.dark-mode .summary-card {\n  background: #2d2d2d;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  border-color: rgba(255, 255, 255, 0.05);\n}\n\n.summary-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);\n}\n\n.dark-mode .summary-card:hover {\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n}\n\n.summary-icon {\n  font-size: 2.2rem;\n  color: #3498db;\n  margin-right: 20px;\n  background: rgba(52, 152, 219, 0.1);\n  padding: 16px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.dark-mode .summary-icon {\n  color: #4CA1D8;\n  background: rgba(76, 161, 216, 0.15);\n}\n\n.summary-info {\n  flex: 1;\n}\n\n.summary-info h3 {\n  font-size: 1rem;\n  color: #7f8c8d;\n  margin: 0 0 8px 0;\n  font-weight: 500;\n}\n\n.dark-mode .summary-info h3 {\n  color: #aaa;\n}\n\n.summary-value {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: #2c3e50;\n  line-height: 1.2;\n}\n\n.dark-mode .summary-value {\n  color: #f5f5f5;\n}\n\n.charts-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));\n  gap: 24px;\n  margin-bottom: 32px;\n}\n\n.chart-container {\n  background: white;\n  padding: 24px;\n  border-radius: 16px;\n  margin-bottom: 24px;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  height: 350px;\n}\n\n.dark-mode .chart-container {\n  background: #2d2d2d;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  border-color: rgba(255, 255, 255, 0.05);\n}\n\n.chart-header {\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.chart-header h3 {\n  color: #2c3e50;\n  font-size: 1.2rem;\n  transition: color 0.3s ease;\n  margin: 0;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.chart-header h3 svg {\n  color: #3498db;\n}\n\n.dark-mode .chart-header h3 {\n  color: #f5f5f5;\n}\n\n.dark-mode .chart-header h3 svg {\n  color: #4CA1D8;\n}\n\n.analytics-insights {\n  background: white;\n  padding: 24px;\n  border-radius: 16px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n}\n\n.dark-mode .analytics-insights {\n  background: #2d2d2d;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  border-color: rgba(255, 255, 255, 0.05);\n}\n\n.analytics-insights h3 {\n  color: #2c3e50;\n  margin: 0 0 16px 0;\n  font-size: 1.2rem;\n  font-weight: 600;\n}\n\n.dark-mode .analytics-insights h3 {\n  color: #f5f5f5;\n}\n\n.insights-list {\n  display: grid;\n  gap: 16px;\n}\n\n.insight-item {\n  background: #f8f9fa;\n  padding: 16px;\n  border-radius: 12px;\n  color: #7f8c8d;\n  line-height: 1.5;\n  transition: all 0.3s ease;\n}\n\n.dark-mode .insight-item {\n  background: #3d3d3d;\n  color: #bbb;\n}\n\n.insight-item:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);\n}\n\n.dark-mode .insight-item:hover {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.insight-item strong {\n  color: #2c3e50;\n  margin-right: 8px;\n  font-weight: 600;\n}\n\n.dark-mode .insight-item strong {\n  color: #f5f5f5;\n}\n\n.analytics-filters {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n}\n\n.filter-select {\n  padding: 10px 16px;\n  border: 2px solid #e0e0e0;\n  border-radius: 10px;\n  background: white;\n  color: #2c3e50;\n  transition: all 0.3s ease;\n  font-size: 1rem;\n  cursor: pointer;\n  min-width: 150px;\n}\n\n.dark-mode .filter-select {\n  background: #2d2d2d;\n  border-color: #444;\n  color: #f5f5f5;\n}\n\n.filter-select:focus {\n  outline: none;\n  border-color: #3498db;\n  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);\n}\n\n.dark-mode .filter-select:focus {\n  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.2);\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 24px;\n  margin-bottom: 32px;\n}\n\n.stat-card {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n}\n\n.dark-mode .stat-card {\n  background: #2d2d2d;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  border-color: rgba(255, 255, 255, 0.05);\n}\n\n.stat-title {\n  font-size: 1rem;\n  color: #7f8c8d;\n  margin: 0 0 16px 0;\n  font-weight: 500;\n}\n\n.dark-mode .stat-title {\n  color: #aaa;\n}\n\n.stat-value {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #2c3e50;\n  margin-bottom: 8px;\n}\n\n.dark-mode .stat-value {\n  color: #f5f5f5;\n}\n\n.stat-change {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.change-positive {\n  color: #2ecc71;\n}\n\n.change-negative {\n  color: #e74c3c;\n}\n\n.dark-mode .change-positive {\n  color: #2ecc71;\n}\n\n.dark-mode .change-negative {\n  color: #e74c3c;\n}\n\n.table-container {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  overflow-x: auto;\n  transition: all 0.3s ease;\n}\n\n.dark-mode .table-container {\n  background: #2d2d2d;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  border-color: rgba(255, 255, 255, 0.05);\n}\n\n.analytics-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.analytics-table th,\n.analytics-table td {\n  padding: 12px 16px;\n  text-align: left;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.dark-mode .analytics-table th,\n.dark-mode .analytics-table td {\n  border-bottom-color: rgba(255, 255, 255, 0.05);\n}\n\n.analytics-table th {\n  font-weight: 600;\n  color: #7f8c8d;\n}\n\n.dark-mode .analytics-table th {\n  color: #aaa;\n}\n\n/* Chart tooltips and legends */\n.recharts-default-tooltip {\n  background-color: white !important;\n  border: none !important;\n  border-radius: 10px !important;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;\n  padding: 10px 14px !important;\n}\n\n.dark-mode .recharts-default-tooltip {\n  background-color: #2d2d2d !important;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;\n}\n\n.recharts-tooltip-label {\n  color: #7f8c8d !important;\n  font-size: 0.9rem !important;\n  margin-bottom: 4px !important;\n}\n\n.dark-mode .recharts-tooltip-label {\n  color: #aaa !important;\n}\n\n.recharts-tooltip-item {\n  font-size: 0.9rem !important;\n}\n\n.recharts-legend-item {\n  font-size: 0.9rem !important;\n}\n\n.dark-mode .recharts-legend-item-text {\n  color: #f5f5f5 !important;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .analytics-container {\n    padding: 0;\n  }\n  \n  .analytics-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n  \n  .analytics-header h2 {\n    font-size: 1.6rem;\n  }\n  \n  .time-range-selector {\n    width: 100%;\n    overflow-x: auto;\n    padding-bottom: 4px;\n  }\n  \n  .charts-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .chart-container {\n    padding: 16px;\n    height: 300px;\n  }\n  \n  .summary-card {\n    padding: 16px;\n  }\n  \n  .summary-icon {\n    font-size: 1.8rem;\n    padding: 12px;\n  }\n  \n  .summary-value {\n    font-size: 1.6rem;\n  }\n  \n  .analytics-insights,\n  .table-container,\n  .stat-card {\n    padding: 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .chart-container {\n    height: 250px;\n  }\n  \n  .summary-icon {\n    margin-right: 12px;\n    padding: 10px;\n    font-size: 1.5rem;\n  }\n  \n  .stat-value {\n    font-size: 1.6rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
